import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, Alert } from "reactstrap"
import { get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "common/loader";
import { POLICY_LIST } from "helpers/api_endpoints";
//meta title
document.title = "Terms List";
const PolicyList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [policies, setPolicies] = useState([]);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        get(POLICY_LIST)
            .then(response => {
                const data = response.data;
                setPolicies(data);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, []);


    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg('');
            }, 4000)
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Terms & Conditions" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <Link to="/policy/add" >
                                    <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                </Link>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>Id</Trans></th>
                                                    <th><Trans>Title</Trans></th>
                                                    <th><Trans>Description</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    policies.map((policy, index) => (
                                                        <tr key={index}>
                                                            <td>{policy.id}</td>
                                                            <td>{policy.name}</td>
                                                            <td>{policy.value}</td>
                                                            <td><Link to={{ pathname: `/privacy-policy/update/${policy.id}` }} state={policy}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Update</Trans></button></Link> &nbsp;
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PolicyList
